import { getUserFsValue } from './getUserFsValue';

const getIsFsUser = (user) => user && !!getUserFsValue(user);

export { getIsFsUser };
